import { Box, Button, Menu, MenuItem, Stack } from '@mui/material';
import { useState } from 'react';
import { liveReportService } from '../../../../services/liveReportService';
import AudioPlayer from '../../../AudioPlayer/AudioPlayer';

const AudioPlayerSeparateComp = ({ row, column, rowIdx, disableCallRecordingDownload }) => {
    const [anchorAudio, setAnchorAudio] = useState(null);
    const open = Boolean(anchorAudio);

    const handleClick = (event: any) => {
        setAnchorAudio(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorAudio(null);
    }

    const audit = column?.audit;
    const onDownload = audit ? () => {
        try {
            const ucidValue = row?.[audit.ucidKey];
            const ucid = ucidValue && typeof ucidValue === 'object' ? ucidValue.value : ucidValue;
            const bodyParams = {
                logModule: audit.logModule,
                logAction: 'AUDIO',
                logDescription: JSON.stringify({
                    message_view: `${audit.attributeName} recording download initiated ${ucid ? `for UCID: ${ucid}` : ''}`,
                }),
                attributeName: audit.attributeName,
            }
            liveReportService({ urlParams: 'auditLog', bodyParams });
        } catch (error) {
            console.error('Error recording audio download audit log:', error);
        }
    } : undefined;

    const audioPlayerPopup = (index: any, url: any) => {
        return (
            index !== 0 && <MenuItem key={index}>
                <AudioPlayer url={url} idx={index + 1} disableCallRecordingDownload={disableCallRecordingDownload} onDownload={onDownload} />
            </MenuItem>
        )
    }

    return (
        <>
            <Stack minWidth={'fit-content'} sx={{}}>
                {Array.isArray(row[column.key]) ? (
                    row[column.key]?.length > 1 && (
                        <Box display={'flex'} maxHeight={'35px'}>
                            <div style={{ marginRight: '12px' }}>
                                <AudioPlayer url={row[column.key][0]} idx={rowIdx} disableCallRecordingDownload={disableCallRecordingDownload} onDownload={onDownload} />
                            </div>
                            <Button size="small" variant="contained" onClick={handleClick}>
                                +{row[column.key].length - 1}
                            </Button>
                            <Menu anchorEl={anchorAudio} open={open} onClose={handleClose}>
                                {row[column.key]?.map(
                                    (url: any, index: any) =>
                                        audioPlayerPopup(index, url)
                                )}
                            </Menu>
                        </Box>
                    )
                ) : (
                    <AudioPlayer url={row[column.key]} idx={rowIdx} disableCallRecordingDownload={disableCallRecordingDownload} onDownload={onDownload} />
                )}
            </Stack>
        </>
    )
}

export default AudioPlayerSeparateComp;
